import { Icon } from 'ant-design-vue';
import { ICONFONT_SCRIPT_URL } from '@/config';

const BizIcon = Icon.createFromIconfontCN({
  scriptUrl: ICONFONT_SCRIPT_URL,
});

export default BizIcon;
